let ExpertProfile = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.languages();
        this.languageForm();
        this.qualificationForm();
        this.involvementForm();
        this.accreditationForm();
        this.phones();
        this.emails();
        this.fileChange()
    },

    languages() {
        let _this = this;

        $(document).on('click', 'input.language', function () {
            if ($(this).prop('checked')) {
                $(this).closest('tr').find('input[type=radio]').prop('disabled', false);
            } else {
                $(this).closest('tr').find('input[type=radio]').prop('disabled', true);
            }
        });
    },

    languageForm() {
        const form = $('#languageForm');
        const modal = $('#languageModal');
        const languagesContainer = $('#languagesContainer');
        const submitBtn = Ladda.create(form.find('[type=submit]')[0]);

        form.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtn.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                languagesContainer.html(response.data.html);
                modal.modal('hide');
                submitBtn.stop();
            },
            error: function (err) {
                submitBtn.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });
    },

    qualificationForm() {
        const form = $('#qualificationForm');
        const formEdit = $('#qualificationEditForm');
        const modal = $('#qualificationModal');
        const modalEdit = $('#qualificationEditModal');
        const qualificationsContainer = $('#qualificationsContainer');
        const submitBtn = Ladda.create(form.find('[type=submit]')[0]);
        const submitBtnEdit = Ladda.create(formEdit.find('[type=submit]')[0]);

        form.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtn.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                qualificationsContainer.html(response.data.html);
                modal.modal('hide');
                submitBtn.stop();
                form.resetForm();
            },
            error: function (err) {
                submitBtn.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        formEdit.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtnEdit.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                qualificationsContainer.html(response.data.html);
                modalEdit.modal('hide');
                submitBtnEdit.stop();
                formEdit.resetForm();
            },
            error: function (err) {
                submitBtnEdit.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        $(document).on('click', '.qualification .delete', function () {
            const id = $(this).data('id');

            Swal.fire({
                title: 'Are you sure you want to delete this item?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Delete',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    $.post('/api/expert/qualification/' + id, {
                        _method: 'DELETE'
                    }, response => {
                        toastr.success(response.data.message);
                        qualificationsContainer.html(response.data.html);
                    });
                }
            });
        });

        $(document).on('click', '.qualification .edit', function () {
            const id = $(this).data('id');
            console.log('Editing: ' + id);

            $.get('/api/expert/qualification/' + id, response => {
                console.log(response);
            });
        });

        $(document).on('click', '.qualification .edit', function () {
            const id = $(this).data('id');
            formEdit.attr('action', '/api/expert/qualification/' + id);

            $.get('/api/expert/qualification/' + id, response => {
                formEdit.find('[name=qualification_type_id]').val(response.data.attributes.qualification_type_id);
                formEdit.find('[name=topic]').val(response.data.attributes.topic);
                formEdit.find('[name=institution]').val(response.data.attributes.institution);
                formEdit.find('[name=completed_at]').val(response.data.attributes.completed_at_formatted);
            });
        });
    },

    involvementForm() {
        const form = $('#involvementForm');
        const formEdit = $('#involvementEditForm');
        const modal = $('#involvementModal');
        const modalEdit = $('#involvementEditModal');
        const involvementsContainer = $('#involvementsContainer');
        const submitBtn = Ladda.create(form.find('[type=submit]')[0]);
        const submitBtnEdit = Ladda.create(formEdit.find('[type=submit]')[0]);

        form.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtn.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                involvementsContainer.html(response.data.html);
                modal.modal('hide');
                submitBtn.stop();
                form.resetForm();
            },
            error: function (err) {
                submitBtn.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        formEdit.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtnEdit.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                involvementsContainer.html(response.data.html);
                modalEdit.modal('hide');
                submitBtnEdit.stop();
                formEdit.resetForm();
            },
            error: function (err) {
                submitBtnEdit.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        $(document).on('click', '.involvement .delete', function () {
            const id = $(this).data('id');

            Swal.fire({
                title: 'Are you sure you want to delete this item?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Delete',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    $.post('/api/expert/involvement/' + id, {
                        _method: 'DELETE'
                    }, response => {
                        toastr.success(response.data.message);
                        involvementsContainer.html(response.data.html);
                    });
                }
            });
        });

        $(document).on('click', '.involvement .edit', function () {
            const id = $(this).data('id');
            formEdit.attr('action', '/api/expert/involvement/' + id);

            $.get('/api/expert/involvement/' + id, response => {
                formEdit.find('[name=involvement_type_id]').val(response.data.attributes.involvement_type_id);
                formEdit.find('[name=description]').val(response.data.attributes.description);
                formEdit.find('[name=completed_at]').val(response.data.attributes.completed_at_formatted);
            });
        });
    },

    accreditationForm() {
        const form = $('#accreditationForm');
        const formEdit = $('#accreditationEditForm');
        const modal = $('#accreditationModal');
        const modalEdit = $('#accreditationEditModal');
        const accreditationsContainer = $('#accreditationsContainer');
        const submitBtn = Ladda.create(form.find('[type=submit]')[0]);
        const submitBtnEdit = Ladda.create(formEdit.find('[type=submit]')[0]);

        form.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtn.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                accreditationsContainer.html(response.data.html);
                modal.modal('hide');
                submitBtn.stop();
                form.resetForm();
                $('.select').select2('val', '');
                $('.select2').trigger('change');
            },
            error: function (err) {
                submitBtn.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        formEdit.ajaxForm({
            beforeSubmit: function () {
                $('.form-group').removeClass('has-error');
                submitBtnEdit.start();
            },
            success: function (response) {
                toastr.success(response.data.message);
                accreditationsContainer.html(response.data.html);
                modalEdit.modal('hide');
                submitBtnEdit.stop();
                formEdit.resetForm();
            },
            error: function (err) {
                submitBtnEdit.stop();

                let error = err.responseJSON;

                if (error.errors) {
                    toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                } else {
                    toastr.error(error.message);
                }

            }
        });

        $(document).on('click', '.accreditation .delete', function () {
            const id = $(this).data('id');

            Swal.fire({
                title: 'Are you sure you want to delete this item?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Delete',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    $.post('/api/expert/accreditation/' + id, {
                        _method: 'DELETE'
                    }, response => {
                        toastr.success(response.data.message);
                        accreditationsContainer.html(response.data.html);
                    });
                }
            });
        });

        $(document).on('click', '.accreditation .edit', function () {
            const id = $(this).data('id');
            formEdit.attr('action', '/api/expert/accreditation/' + id);

            $.get('/api/expert/accreditation/' + id, response => {
                formEdit.find('[name=level]').val(response.data.attributes.level);
                formEdit.find('[name=accreditation_type_id]').val(response.data.attributes.accreditation_type_id);
                formEdit.find('[name=pre_accreditation_at]').val(response.data.attributes.pre_accreditation_at_formatted);
                formEdit.find('[name=pre_accreditation_place]').val(response.data.attributes.pre_accreditation_place);
                formEdit.find('[name=pre_accreditation_type]').val(response.data.attributes.pre_accreditation_type);
                formEdit.find('[name=pre_accreditation_number]').val(response.data.attributes.pre_accreditation_number);

                formEdit.find('[name=accreditation_at]').val(response.data.attributes.accreditation_at_formatted);
                formEdit.find('[name=accreditation_place]').val(response.data.attributes.accreditation_place);
                formEdit.find('[name=accreditation_type]').val(response.data.attributes.accreditation_type);
                formEdit.find('[name=accreditation_number]').val(response.data.attributes.accreditation_number);
                formEdit.find('[name=other_wco_expertise]').val(response.data.attributes.other_wco_expertise);

                $('.select2').trigger('change');
            });
        });

        $('.other-wco-expertise').hide();
        $(document).on('change', '[name=accreditation_type_id]', function () {
            if ($(this).find('option:selected').data('other') === 1) {
                $('.other-wco-expertise').show();
            } else {
                $('.other-wco-expertise').hide();
            }
        });

        $(document).on('keypress', '[name=pre_accreditation_number]', function (event) {
            let regex = /[0-9]/;
            if (!regex.test(event.key)) {
                event.returnValue = false;
                if (event.preventDefault) event.preventDefault();
            }
        });
        $(document).on('keypress', '[name=accreditation_number]', function (event) {
            let regex = /[0-9]/;
            if (!regex.test(event.key)) {
                event.returnValue = false;
                if (event.preventDefault) event.preventDefault();
            }
        });
    },

    phones() {
        let _this = this;
        let template = $('#phoneTemplate').html();
        let count = $('.phone').length;

        $(document).on('click', '#addPhone', function () {
            $('#phonesContainer').append(replaceAll(template, ':number:', count++));
        });

        $(document).on('click', '.phone .remove', function () {
            const phone = $(this).closest('.phone');

            Swal.fire({
                title: 'Are you sure you want to delete this phone?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Delete',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    phone.remove();
                }
            });
        });

        $(document).on('keypress', '.phone input', function (event) {
            let regex = /[0-9]/;
            if (!regex.test(event.key)) {
                event.returnValue = false;
                if (event.preventDefault) event.preventDefault();
            }

        });
    },

    emails() {
        let _this = this;
        let template = $('#emailTemplate').html();
        let count = $('.email').length;

        if (count === 1) {
            template = replaceAll(template, ':number:', count++);
            template = replaceAll(template, ':number:', count++);

            $('#emailsContainer').append(template);
        }

        $(document).on('click', '#addEmail', function () {
            $('#emailsContainer').append(replaceAll(template, ':number:', count++));
        });

        $(document).on('click', '.email .remove', function () {
            const email = $(this).closest('.email');

            $(document).on('click', '.email .remove', function () {
                const email = $(this).closest('.email');

                Swal.fire({
                    title: 'Are you sure you want to delete this email?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm Delete',
                    cancelButtonText: 'Cancel',
                    icon: 'warning'
                }).then((result) => {
                    if (result.value) {
                        email.remove();
                    }
                });
            });
        });

        $(document).on('change', 'input[type=radio][name^=emails]', function() {
            $('input[type=radio][name^=emails]:checked').not(this).prop('checked', false);
        });
    },

    fileChange()
    {
        $('#cv').on('change',function (event) {
            const file = $(this)[0]?.files[0]?.name
            $('#file-name')[0].innerHTML = file ?? ''
            $('p.pt-1>span')[0].innerHTML = moment().format('YYYY-MM-DD')
        })
    }
};

$('#refresh_event').on('change',function (){
    if($(this).prop('checked')){
       $('#refresh_date').removeClass('d-none')
    }
    else{
        $('#refresh_date').addClass('d-none')

    }
})
$().ready(() => {
    window.ExpertProfile = ExpertProfile;
    window.ExpertProfile.init();
});
